import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { Invoice } from 'gung-standard';
import { map, Observable } from 'rxjs';
import { JeevesInvoiceTableComponent } from '../../components/jeeves-invoice-table/jeeves-invoice-table.component';
import { JeevesInvoiceListConfigService } from '../jeeves-invoice-list-config/jeeves-invoice-list-config.service';

@Injectable({
  providedIn: 'root'
})
export class JeevesInvoiceListTableConfigService extends JeevesInvoiceListConfigService {
  getItems(): Observable<Invoice[]> {
    return this.invoiceService.getOpenInvoices().pipe(
      map(invoices => {
        this.hasStatus = invoices.some(invoice => invoice.extra?.gme?.status);
        return invoices;
      }),
      map(results =>
        results.sort((a, b) => {
          const aDate = new Date(a?.extra?.fh?.faktdat);
          const bDate = new Date(b?.extra?.fh?.faktdat);
          if (aDate < bDate) {
            return 1;
          } else if (aDate > bDate) {
            return -1;
          }
          
          return a?.id.localeCompare(b?.id);
        })
      )
    );
  }

  getLayouts(): ListLayout<Invoice>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => JeevesInvoiceTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Invoice grid'
      }
    ];
  }
}
